import React from 'react'
import ReactDOM from 'react-dom'
import SearchPage from '../searches/search_page'

document.addEventListener('DOMContentLoaded', () => {
  const contentTag = document.getElementById('filters')
  const queryResponse = JSON.parse(contentTag.getAttribute('data-query-response'))
  const initialSearchResults = window.Search.Data
  const mount = document.getElementById('sidebar')
  ReactDOM.render(
    <SearchPage filters={queryResponse} initialSearchResults={initialSearchResults} />, mount)
})
